import { publicFetch } from "api/publicFetch";

/**
 * @typedef {
 * {
 *  "courseId": number;
 *  "courseName": string;
 *  "duration": string;
 *  "language": string;
 *  "difficultyLevel": string;
 *  "certificate": number;
 *  "mrp": string;
 *  "sellingPrice": string;
 *  "totalSessionCount": number;
 * }
 * } Response
 */

/**
 * Get courses
 * @returns {Promise<Response[]>} Response
 */
const getCourses = async () => {
  const { data } = await publicFetch.get("/courses");
  return data;
};

export default getCourses;
